import chroma from "chroma-js";
import { COLOR_SCHEME_LIGHT } from "../../THEME_BASE";
import { opacify } from "../../utils";
const darken = (color, ratio) => chroma.mix(color, "#000", ratio).hex();
const inputColors = (completeGlobal, gray, variant, colorScheme, colors, primaryTextColor) => {
  const background = colorScheme === COLOR_SCHEME_LIGHT ? completeGlobal.contentBackground : colors.gray[7];
  return {
    background,
    backgroundDisabled: darken(background, 0.25),
    border: colorScheme === COLOR_SCHEME_LIGHT ? colors.gray[2] : opacify(colors.default[3], 0.74),
    borderFocus: variant.light.info,
    boxShadow: `inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px ${opacify(variant.light.info, 0.4)}`,
    color: primaryTextColor,
    colorDisabled: gray[60],
    placeholder: gray[60]
  };
};
export default inputColors;
